import { useDispatch } from 'react-redux';

import { AppDispatch } from '../StoreProvider';

export const useAppDispatch = () => useDispatch<AppDispatch>();
